import React from "react";
import __i18n from "../intl/__i18n";


export const enum PaymentGateway {
  "None" = "none",
  "VasMtn" = "vas_mtn",
  "VasMci" = "vas_mci",
  "VasMciInAppPurchase" = "vas_mci_in_app_purchase",
  "Banking" = "banking",
  "Charkhone" = "charkhone",
  "Cafebazaar" = "cafebazaar",
  "InternalUserBalance" = "internal_user_balance",
  "VasMobinVan" = "vas_mobin_van",
  "VasMobinVanInAppPurchase" = "vas_mobin_van_in_app_purchase",
  "VasRightel" = "vas_rightel",
  "FinnoTech" = "finno_tech",
  "ThirdPartyPayment" = "third_party_payment",
  "UsherPayment"="usher_payment"
}


export const PaymentGatewayOptions = [{
  value: PaymentGateway.None,
  label: __i18n("Not Specified")
},{
  value: PaymentGateway.VasMtn,
  label: __i18n("Vas Mtn")
}, {
  value: PaymentGateway.VasMci,
  label: __i18n("Vas Mci")
}, {
  value: PaymentGateway.VasMciInAppPurchase,
  label: __i18n("Vas Mci In App Purchase")
}, {
  value: PaymentGateway.Banking,
  label: __i18n("Banking")
}, {
  value: PaymentGateway.Charkhone,
  label: __i18n("Charkhone")
}, {
  value: PaymentGateway.Cafebazaar,
  label: __i18n("Cafebazaar")
}, {
  value: PaymentGateway.InternalUserBalance,
  label: __i18n("Internal User Balance")
}, {
  value: PaymentGateway.VasMobinVan,
  label: __i18n("Vas Mobin Van")
}, {
  value: PaymentGateway.VasMobinVanInAppPurchase,
  label: __i18n("Vas Mobin Van In App Purchase")
},{
  value: PaymentGateway.VasRightel,
  label: __i18n("Vas Rightel")
},{
  value: PaymentGateway.FinnoTech,
  label: __i18n("Finno Tech")
},{
  value: PaymentGateway.ThirdPartyPayment,
  label: __i18n("Third Party Payment")
},{
  value: PaymentGateway.UsherPayment,
  label: __i18n("Cinema Online")
}];



